<script>
export default {
  name: "SavedStatusIndicator",
  props: {
    status: {
      type: String
    }
  },
  data() {
    return {
      tooltipText: 'We cant save you changes you changes  '
    }
  },
  computed: {
    saving() {
      return this.status === 'SAVING';
    },
    error() {
      return this.status === 'ERROR';
    }
  }
}
</script>

<template>
<div class="saved-status-indicator">
  <template v-if="saving">
    <font-awesome-icon :icon="['fas', 'arrows-rotate']"
                       class="saved-status-indicator__icon fa-spin"
    />
    <span class="saved-status-indicator__label">Saving</span>
  </template>
  <template v-else-if="error">
    <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                       class="saved-status-indicator__icon"
    />
    <span class="saved-status-indicator__label"
          v-tooltip.top="{ value: tooltipText, class: 'rate-arg-tooltip' }"
    >Saving error...</span>
  </template>
  <template v-else>
    <font-awesome-icon :icon="['fas', 'cloud']"
                       class="saved-status-indicator__icon"
    />
    <span class="saved-status-indicator__label">Saved</span>
  </template>
</div>
</template>


<style lang="scss" scoped>
.saved-status-indicator {
  color: #7835a6;
  &__icon {
    margin-right: 5px;
  }
  &__label {
    font-weight: 600;
    font-size: 12px;
  }
}

</style>